module.exports = __webpack_public_path__ + "static/软件企业证书2022-2023-7cc77af6296670299f9fa8e399b1a33f.jpg";